import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTenant } from '../../../contexts/TenantContext'
import getPickupOrS2SStoresClient from '../../../common/clients/getPickupOrS2SStoresClient'
import SelectorModal from '../../../components/SelectorModal'
import CollectionSearchComponent from '../../../components/SelectorModal/CollectionSearchComponent'
import Store from '../../../components/SelectorModal/Store'
import { getCustomSort } from '../../../Helpers'
import texts from '../../../common/texts.json'

const PickUpStoresModal = ({ modalIsOpen, closeModalAction }) => {
  const [sortStores, setSortStores] = useState([])
  const { tenant } = useTenant()

  const getStores = async () => {
    try {
      const stores = await getPickupOrS2SStoresClient(tenant)
      setSortStores(getCustomSort(stores, 'name', 'DESC'))
    } catch (error) {
      closeModalAction()
    }
  }

  useEffect(() => {
    if (modalIsOpen && (!sortStores || sortStores.length === 0)) {
      getStores()
    }
  }, [modalIsOpen])

  return (
    <>
      {sortStores && sortStores.length > 0 && (
        <SelectorModal modalIsOpen={modalIsOpen} closeModalAction={closeModalAction}>
          <CollectionSearchComponent
            collection={sortStores}
            searchKeys={['name', 'address', 'location.commune.name', 'location.region.name', 'street']}
            title={texts.PICKUP_STORES_MODAL.TITLE}
            singleElementMessage={texts.PICKUP_STORES_MODAL.SINGLE_MESSAGE}
            SearchResultElement={Store}
            searchPlaceholder={texts.PICKUP_STORES_MODAL.SEARCH_PLACE_HOLDER}
            noFoundMessage={texts.PICKUP_STORES_MODAL.NOT_FOUND_MESSAGE}
            closeModalAction={closeModalAction}
          />
        </SelectorModal>
      )}
    </>
  )
}

PickUpStoresModal.propTypes = {
  modalIsOpen: PropTypes.bool,
  closeModalAction: PropTypes.func.isRequired,
}

export default PickUpStoresModal
